<template>
  <footer class="container-fluid p-0" :class="{ 'dont_print': store.state.customer.printing }">
    <!--  general info about company  -->
    <div class="requisites-container px-3 py-4">
      <div class="container d-flex requisites-sub-container p-1">

        <div class="requisites-sub-container__data font-medium col-8">
          <div class="mob-font tablet-font">
              <div class="fw-bold pb-2 ps-1">{{$t('requisites').toUpperCase()}}</div>
              <div class="requisites-container__items">

                <div class="p-1">{{store.state.company.company_name}}</div>
                <div class="p-1">{{$t('address')}}:
                  <a class="a-display-style"
                     href="https://www.google.com/maps/place/Rugi%C5%B3+g.+4A,+Vilnius+08418/@54.7408595,25.2742982,19.5z/data=!4m5!3m4!1s0x46dd91225bf6bfe5:0xc4a10877939081a!8m2!3d54.7408916!4d25.2743853">
                  {{store.state.company.company_address}}
                </a>
                </div>
                <div class="p-1">{{$t('company_code')}}: {{store.state.company.company_code}}</div>
                <div class="p-1">{{$t('vat_code')}}: {{store.state.company.vat_code}}</div>
                <div class="p-1">{{$t('tel')}}:
                  <a class="a-display-style" :href="'tel:'+$filters.phoneBeautify(store.state.company.phone_number) ">
                    {{$filters.phoneBeautify(store.state.company.phone_number)}}
                  </a>
                </div>
                <div class="p-1">{{$t('email')}}:
                  <a class="a-display-style" :href="'mailto:'+store.state.company.info_mail">{{store.state.company.info_mail}}</a>
                </div>
                <div class="p-1">{{$t('bank_account')}}: {{store.state.company.bank_account}}</div>
                <div class="p-1">{{$t('finance')}}:
                  <a class="a-display-style" :href="'tel:'+$filters.phoneBeautify(store.state.company.finance_phone) ">
                    {{$filters.phoneBeautify(store.state.company.finance_phone)}}
                  </a>
                </div>
                <div class="p-1">{{$t('director')}}:
                  <a class="a-display-style" :href="'tel:'+$filters.phoneBeautify(store.state.company.director_phone) ">
                    {{$filters.phoneBeautify(store.state.company.director_phone)}}
                  </a>
                </div>

              </div>
          </div>
        </div>

        <div class="font-medium col-4 d-flex justify-content-end align-items-center">
          <ul class="mob-font tablet-font p-2">
            <li class="fw-bold">{{$t('working_hours').toUpperCase()}}</li>
            <li>{{store.state.company.working_hours_footer}}</li>
          </ul>
        </div>
      </div>
    </div>

    <!--  cookies, privacy  -->
    <div class="container-fluid bg-white p-3">
      <div class="container private-policy d-flex justify-content-between align-items-center font-medium p-2">
        <div class="d-flex mob-font tablet-font col-6">
          {{$t('all_rights')}}. © {{dateNow}} {{$t('minibus_rental')}} – {{store.state.company.company_name}}.
        </div>
        <div class="d-flex mob-tablet-flex-direction justify-content-end mob-font tablet-font col-6">
          <div class="p-2">
            <slot name="purchase-declaration-link"></slot>
          </div>
          <div class="p-2">
            <slot name="cookies-link"></slot>
          </div>
          <div class="p-2">
            <slot name="privacy-link"></slot>
          </div>
        </div>
      </div>
    </div>

  </footer>

  <ModalComponent id-data="purchaseDeclarationModal" :modal-title="$t('purchase_declaration')">
    <template #body-content>
      <div style="line-height: 1.5rem" v-html="store.state.company.purchase_declaration"></div>
    </template>
  </ModalComponent>

  <ModalComponent id-data="cookiesModal" :modal-title="$t('cookies_consent')">
    <template #body-content>
      <div style="line-height: 1.5rem" v-html="store.state.company.cookies_consent"></div>
    </template>
  </ModalComponent>

  <ModalComponent id-data="privacyModal" :modal-title="$t('privacy_policy')">
    <template #body-content>
      <div style="line-height: 1.5rem" v-html="store.state.company.privacy_policy"></div>
    </template>
  </ModalComponent>

</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore} from "vuex";
import type {PropType} from "vue";
import './footer.scss';
// @ts-ignore
import ModalComponent from "../../components/modal/ModalComponent";

export default defineComponent({
  name: 'FooterComponent',
  components: {ModalComponent},
  props: {},
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  data() {
    return {
      dateNow: 0
    }
  },
  methods: {
    getNowYear(): void {
      const year = new Date();
      this.dateNow = year.getFullYear();
    }
  },
  beforeMount() {
    this.getNowYear()
  }
})
</script>

<style scoped type="text/css" media="print">
.dont_print {
  display: none !important;
}
</style>